// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventsBar__events-bar-d831db {
  position: absolute;
  top: 72px;
  inset-inline-start: 16px;
  display: flex;
  flex-direction: column-reverse;
  z-index: 1;
}

.EventsBar__enter-b9f9f4 {
  opacity: 0;
  margin-top: -30px;
}

.EventsBar__enter-active-ccdb24 {
  opacity: 1;
  margin-top: 0;
  transition: opacity 250ms linear, margin-top 250ms linear;
}

.EventsBar__exit-cbb5e5 {
  opacity: 1;
}

.EventsBar__exit-active-adf010 {
  opacity: 0;
  transition: opacity 250ms linear;
}

.EventsBar__fullscreen-de4efd {
  top: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/EventsBar/EventsBar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,UAAA;AACF;;AAEA;EACE,UAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;EACA,aAAA;EACA,yDAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;EACA,gCAAA;AACF;;AAEA;EACE,SAAA;AACF","sourcesContent":[".events-bar {\n  position: absolute;\n  top: 72px;\n  inset-inline-start: 16px;\n  display: flex;\n  flex-direction: column-reverse;\n  z-index: 1;\n}\n\n.enter {\n  opacity: 0;\n  margin-top: -30px;\n}\n\n.enter-active {\n  opacity: 1;\n  margin-top: 0;\n  transition: opacity 250ms linear, margin-top 250ms linear;\n}\n\n.exit {\n  opacity: 1;\n}\n\n.exit-active {\n  opacity: 0;\n  transition: opacity 250ms linear;\n}\n\n.fullscreen {\n  top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"events-bar": `EventsBar__events-bar-d831db`,
	"eventsBar": `EventsBar__events-bar-d831db`,
	"enter": `EventsBar__enter-b9f9f4`,
	"enter-active": `EventsBar__enter-active-ccdb24`,
	"enterActive": `EventsBar__enter-active-ccdb24`,
	"exit": `EventsBar__exit-cbb5e5`,
	"exit-active": `EventsBar__exit-active-adf010`,
	"exitActive": `EventsBar__exit-active-adf010`,
	"fullscreen": `EventsBar__fullscreen-de4efd`
};
module.exports = ___CSS_LOADER_EXPORT___;
